import { VarBoolValue, VarType } from '../server';

export const getVarEmptyValue = (varType: VarType): string | null => {
  switch (varType) {
    case VarType.list:
      return '[]';

    case VarType.dict:
      return '{}';

    case VarType.bool:
      return VarBoolValue.False;

    case VarType.date:
    case VarType.datetime:
    case VarType.attachment:
      return null;

    case VarType.str:
    case VarType.num:
    case VarType.expr:
    default:
      return '';
  }
};
